import type ApiRequestError from 'src/core/models/api/ApiRequestError';
import { Platform } from 'react-native';
import ThermenRepository from 'src/data/repositories/ThermenRepository';
import Constants from 'src/core/utils/Constants';
import toErrorMessage from 'src/core/utils/ErrorMessages';
import Translations from 'src/core/utils/Translations';
import type ApiSettings from 'src/core/models/api/ApiSettings';
import { create } from 'zustand';
import { combine } from 'zustand/middleware';

export const useApiSettingsStore = create(
	combine(
		{
			apiSettings: null as ApiSettings | null,
			apiSettingsLoading: false,
			apiSettingsErrorMessage: null as string | null,
		},
		(set, get) => {
			const fetchApiSettings = async () => {
				set({ apiSettingsErrorMessage: null });

				if (get().apiSettings === null) {
					set({ apiSettingsLoading: true });
				}

				await ThermenRepository.getSettings()
					.then((response) => {
						const data = response?.data ?? null;
						if (data === null) {
							set({
								apiSettingsErrorMessage: Translations.unknownErrorOccurred,
							});
							return;
						}

						set({ apiSettings: data });
					})
					.catch((error: ApiRequestError) => {
						const errorMessage = toErrorMessage(error);
						set({ apiSettingsErrorMessage: errorMessage });
					})
					.finally(() => {
						set({ apiSettingsLoading: false });
					});
			};

			const canShowAppUpdateDialog = () => {
				const isAppPlatform = Platform.OS === Constants.platformAndroid || Platform.OS === Constants.platformIos;
				if (!isAppPlatform) {
					return false;
				}

				const apiSettings = get().apiSettings;
				if (!apiSettings) {
					return false;
				}

				return apiSettings.should_update_app || apiSettings.should_mandatory_update_app;
			};

			return {
				fetchApiSettings,
				canShowAppUpdateDialog,
			};
		},
	),
);
